import { BrandliveEvent, TranslationUploadWarning, TranslateString, NestedTranslateStrings } from '../types/working-model';
import blAuth from './bl-auth/bl-auth';
import { GetTranslationService, Post, PutJson, PutTranslationService, isSameOrigin } from './helpers';

export const getTranslationFile = async (token: string, eventUuid: string): Promise<any> => {
	return GetTranslationService(`/translation/${eventUuid}?v=${Date.now()}`, token);
};

const makeTranslationFileUploadRequest = async (
	token: string,
	formData: FormData,
	eventUuid: string,
	language: string
): Promise<{ warnings: TranslationUploadWarning[], manifests: Record<string, string> }> => {
	const sameOrigin = isSameOrigin();
	const getHeaders = () => {
		if (sameOrigin) {
			return {};
		} else {
			return {
				"Authorization": `Bearer ${blAuth.accessToken}`
			};
		}
	};

	const res = await fetch(`${process.env.REACT_APP_TRANSLATIONS_SERVICE_HOST}/translation/${eventUuid}/${language}`, {
		method: 'PUT',
		headers: getHeaders() as RequestInit['headers'],
		body: formData,
		credentials: sameOrigin ? "include" as RequestCredentials : undefined
	});

	const data = await res.json();

	if (!res.ok) {
		throw {
			status: res.status,
			statusText: res.statusText,
			error: data
		};
	}

	return data;
};

export const uploadTranslationFile = async (
	token: string,
	file: File,
	eventUuid: string,
	language: string
): Promise<{
	warnings: TranslationUploadWarning[],
	manifests: Record<string, string>
}> => {
	const formData = new FormData();
	formData.append('file', file);

	return await makeTranslationFileUploadRequest(token, formData, eventUuid, language);
};

export const saveTranslationFile = async (token: string, eventUuid: string): Promise<boolean> => {
	return await PutTranslationService(`/translation/${eventUuid}/save`, token);
};

export const commitTranslationFile = async (token: string, eventUuid: string): Promise<BrandliveEvent> => {
	return await PutJson({
		path: `/v3/admin/events/${eventUuid}/translations`,
		token,
		data: {}
	});
};

export const generateGeneralTranslation = async (
	token: string,
	content: string | { [key: string]: string },
	languages: string[],
	defaultLanguage: string,
	translateKeys?: string[]
): Promise<NestedTranslateStrings | TranslateString> => {
	return Post(`/v3/admin/events/generate-general-translation`, token, { content, languages, defaultLanguage, translateKeys }, false);
};
